import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FlexRow } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { FormattedCurrency } from '../../../../../components/formatted-currency';
import { useModal } from '../../../../../hooks/use-modal';
import { useProductDetailsContext } from '../../../use-product-details-context';
import { useProductSuppliers } from './use-product-suppliers';
import { AddSupplierModal } from './add-supplier-modal/add-supplier-modal';
import { SupplierNameCell } from './components/supplier-name-cell/supplier-name-cell';
import { messages } from './product-suppliers-tab.messages';
import style from './product-suppliers-tab.module.less';

export const ProductDetailsSuppliersV3 = () => {
  const { productId } = useProductDetailsContext();
  const { suppliers, isLoading, hasError, reload } = useProductSuppliers(productId);
  const { isOpen: isAddModalOpen, open: openAddModal, close: closeAddModal } = useModal(false);

  return (
    <>
      {isAddModalOpen && <AddSupplierModal close={closeAddModal} onSuccess={reload} />}
      <div className={style['content-card']}>
        <FlexRow className={style['card-header']}>
          <div>
            <Text element='div' textType={TextType.H4} value={messages.title} />
            <Text className={style['card-subtitle']} element='div' textType={TextType.Caption} value={messages.subtitle} />
          </div>
          <Button className={style['add-supplier-btn']} onClick={openAddModal} theme={THEME_CONSTANTS.secondary}>
            <FontAwesomeIcon icon={faPlus} />
            <FormattedMessage {...messages.assignSupplierButton} />
          </Button>
        </FlexRow>

        <div className={style['suppliers-grid']}>
          <div className={style['suppliers-grid-header']}>
            <Text element='div' textType={TextType.Label} value={messages.columnSupplierName} />
            <Text element='div' textType={TextType.Label} value={messages.columnUomSku} />
            <Text element='div' textType={TextType.Label} value={messages.columnSupplierSku} />
            <Text element='div' textType={TextType.Label} value={messages.columnCost} />
          </div>

          {isLoading ? (
            <div className={style['suppliers-loading']}>
              <LoadingIndicator theme='grey' />
            </div>
          ) : (
            <>
              {hasError && (
                <div className={style['suppliers-feedback']}>
                  <Text element='div' textType={TextType.Paragraph} value={messages.loadingError} />
                </div>
              )}

              {!hasError && suppliers.length === 0 && (
                <div className={style['suppliers-feedback']}>
                  <Text element='div' textType={TextType.Paragraph} value={messages.emptyState} />
                </div>
              )}

              {suppliers.map((supplier) => (
                <div key={supplier.productSupplierGuid} className={style['suppliers-row']}>
                  <div className={style['cell-link']}>
                    <SupplierNameCell supplierId={supplier.supplierId} supplierName={supplier.supplierName} />
                  </div>
                  <Text className={style['cell-readonly']} element='div' textType={TextType.Caption} value={supplier.uomSku ?? ''} />
                  <Text className={style['cell-readonly']} element='div' textType={TextType.Caption} value={supplier.supplierSku} />
                  <div className={style['cell-readonly']}>
                    <FormattedCurrency value={supplier.cost} />
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};
